import { Toaster } from 'sonner'
import { AlertCircle, AlertTriangle, CheckCircle, Info } from 'lucide-react'
import { ToastContext } from './toast-context'

type ToastProviderProps = {
  children: React.ReactNode
}

export function ToastProvider({ children }: ToastProviderProps) {
  return (
    <ToastContext.Provider value={true}>
      {children}
      <Toaster
        position="top-right"
        duration={8000}
        closeButton
        icons={{
          success: <CheckCircle className="size-5 shrink-0 text-sage" />,
          error: <AlertCircle className="size-5 shrink-0 text-destructive" />,
          warning: <AlertTriangle className="size-5 shrink-0 text-amber" />,
          info: <Info className="size-5 shrink-0 text-steel" />,
        }}
        toastOptions={{
          classNames: {
            toast:
              '!flex !items-start !gap-3 !p-4 !rounded-lg !border-l-4 !border-y !border-r !border-y-border !border-r-border !bg-card !shadow-lg !text-foreground',
            title: '!text-sm !font-medium !text-foreground',
            description: '!text-xs !text-muted-foreground',
            closeButton:
              '!left-auto !right-0 !top-3 !translate-x-0 !translate-y-0 !bg-card !border-border !text-muted-foreground hover:!bg-muted',
            success: '!border-l-sage',
            error: '!border-l-destructive',
            warning: '!border-l-amber',
            info: '!border-l-steel',
          },
        }}
      />
    </ToastContext.Provider>
  )
}
